import { Box, styled } from '@mui/material';

const ECRowGap = 24;
const ECCardPadding = 24;

export const CardContainerBox = styled(Box)(() => ({
  width: `calc(100% - ${ECCardPadding * 2}px)`,
  height: `calc(100% - ${ECCardPadding * 2}px)`,
  padding: `${ECCardPadding}px`,

  display: 'flex',
  flexDirection: 'column',
  rowGap: `${ECRowGap}px`,
}));
